import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Auth from "./component/Auth/auth";
import IRouter from "./component/Interface/IRouter";
import mainRoutes from "./component/routes/routes";
import PrivateRoutes from "./View/Private.index";
import Login from "./View/Public/Login/Login";
import { useAllowedPages } from "./context/AllowedPagesContext";
import PublicDocViewer from "./View/PublicDocViewer";

function PrivateRouter() {
  const auth = Auth.checkAuth();
  console.log("Auth Status:", auth); // Debugging line
  return auth ? <PrivateRoutes /> : <Navigate to="/login" />;
}

const Router = () => {
  const { isPageAllowed } = useAllowedPages();
  const filteredRoutes = mainRoutes.filter((route: IRouter) =>
    isPageAllowed(route.path)
  );

  return (
    <Routes>

      {/* ✅ PUBLIC DOCS */}
      <Route path="/docs/:docName" element={<PublicDocViewer />} />

      {/* ✅ PUBLIC LOGIN */}
      <Route path="/login" element={<Login />} />

      {/* ✅ PRIVATE ROUTES */}
      <Route element={<PrivateRouter />}>
        {filteredRoutes.map((data: IRouter) => (
          <Route
            key={data.path}
            path={data.path + "/*"}
            element={<data.element />}
          />
        ))}
      </Route>

      {/* fallback */}
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default Router;
